import { render, staticRenderFns } from "./TenantPreview.vue?vue&type=template&id=54f53fe0&"
import script from "./TenantPreview.vue?vue&type=script&lang=js&"
export * from "./TenantPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports